<template>
  <div class="footer">
    <div class="logo">
      <!-- Temporary logo (replace with actual image) -->
      <img src="../assets/footer-logo-2.png" alt="eduplus logo" class="logo" />
    </div>

    <div class="info">
      <p>55 Jolly Mariner, Coosan Road, Athlone, Co. Westmeath, Ireland</p>
      <p>info@eduplus.com</p>
      <p>© 2025 Eduplus. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebFooter",
};
</script>

<style scoped>
.footer {
  margin-top: 30px;
  height: 300px;
  width: 100%;
  border-top: 1px dotted lightgray;
  background-color: #003e29;
  padding-top: 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.logo img {
  width: 200px; /* Adjust logo size as needed */
  margin-top: 20px;
}

.description {
  padding-top: 10px;
  font-family: "Open Sans", sans-serif;
  font-weight: 350;
  font-size: 16px;
  color: grey;
}

.info {
  margin-top: 15px;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: lightgray;
  line-height: 1.6;
}
</style>
